import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { lang } from 'src/utils';

import { SimpleDialog } from '../simpleDialog';
import { PreviewLocationGroupsModalProps } from './PreviewLocationGroupsModal.interface';
import {
  Container,
  DivContainer,
  DivContainer1,
  LocationGroupButton,
  LocationGroupText,
  ModalContainer,
} from './PreviewLocationGroupsModal.styled';

export const PreviewLocationGroupsModal = (
  props: PreviewLocationGroupsModalProps,
) => {
  const navigate = useNavigate();

  const onHandleLocationGroup = (id: number) => {
    navigate(`/locations/group/${id}/timings`);
  };

  return (
    <SimpleDialog
      {...props}
      cancelText={lang.cancel}
      confirmText={lang.confirm}
      title={`${props.locationName} ${props.title}`}
      modalSize="md"
      hideButton
      onClickCancel={props.onClose}
      onClickConfirm={() => {}}>
      <Container>
        {props.selectedLocationGroups.map((group) => (
          <ModalContainer key={group.id}>
            <DivContainer1>
              <CustomTooltip
                width={500}
                placement="bottom"
                title={group.name}
                overflowLineNumber={1}>
                <LocationGroupText>{group.name}</LocationGroupText>
              </CustomTooltip>
            </DivContainer1>
            <DivContainer>
              <CustomTooltip
                width={500}
                placement="bottom"
                title={group.channel_name}
                overflowLineNumber={1}>
                <LocationGroupText>{group.channel_name}</LocationGroupText>
              </CustomTooltip>
              <LocationGroupButton
                variant="text"
                onClick={() => onHandleLocationGroup(group.id)}>
                {lang.previewLocationGroupsModal.viewLocationGroup}
                <ArrowForwardIcon />
              </LocationGroupButton>
            </DivContainer>
          </ModalContainer>
        ))}
      </Container>
    </SimpleDialog>
  );
};
